<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0" v-on:keypress.enter.prevent="getTaxPaymentList(1)">
                    <input
                        v-model="search.code"
                        class="form-control mr-sm-2"
                        type="text"
                        placeholder="รหัสบัญชี"/>

                    <button v-model="search.code"
                            @click="getTaxPaymentList(1)"
                            class="btn btn-success my-2 my-sm-0"
                            type="button">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                    &nbsp
                    <button class="btn btn-warning my-2 my-sm-0"
                            @click="createTaxPaymentAccount"
                            type="button">
                        <icon name="plus"></icon>
                        เพิ่มรหัสบัญชี
                    </button>
                    &nbsp
                </form>
            </div>
        </nav>

        <div class="col-sm-12 table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th scope="col">ลำดับ</th>
                    <th scope="col">รหัสบัญชี</th>
                    <th scope="col">รายการ</th>
                    <th scope="col" width="150px">แก้ไข</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,index) in tableList">
                    <td>{{ ((dataPaginate.current_page - 1) * 10) + (index + 1) }}</td>
                    <td>{{ data.code }}</td>
                    <td>{{ data.name }}</td>
                    <td>
                        <button type="button" class="btn btn-primary" @click="showTaxPaymentAccount(data.id)">
                            <icon name="pencil-alt"></icon>
                            แก้ไข
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <b-modal hide-header hide-footer ref="create_account">
            <div>
                <h2 style="text-align: center">เพิ่ม / แก้ไขรายการบัญชี</h2>
                <div class="row form-group">
                    <div class="col-4 text-right">รหัสบัญชี</div>
                    <div class="col-6">
                        <input type="text" class="form-control" v-model="form.code" disabled/>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-4 text-right">รายการบัญชี</div>
                    <div class="col-6">
                        <input type="text" class="form-control" v-model="form.name"/>
                    </div>
                </div>
                <div class="col text-center mt-3">
                    <button type="button" class="btn btn-success" @click="saveTaxPaymentAccount">
                        <icon name="save"></icon>
                        บันทึก
                    </button>
                    &nbsp;&nbsp;
                    <button type="button" class="btn btn-outline-secondary"
                            @click="hideTaxPaymentAccountModal">
                        <icon name="times"></icon>
                        ยกเลิก
                    </button>
                </div>
            </div>
        </b-modal>
        <div v-if="tableList.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getTaxPaymentList(dataPaginate.current_page)">
            </vue-pagination>
        </div>
        <!--        <pre class="alert-danger">{{tableList}}</pre>-->
    </div>
</template>

<script>
import VuePagination from "../../Pagination";

export default {
    name: "TaxPaymentAccount",
    components: {VuePagination},
    data() {
        return {
            form: {
                id: '',
                code: '',
                name: ''
            },
            tableList: [],
            dataPaginate: {
                current_page: 1,
                from: 1,
                last_page: 1,
                per_page: 1,
                total: 1,
                to: 1
            },
            search: {
                code: ''
            }
        }
    },
    created() {
        this.getTaxPaymentList();
    },
    computed: {},
    methods: {
        showTaxPaymentAccountModal() {
            this.$refs.create_account.show();
        },
        hideTaxPaymentAccountModal() {
            this.$refs.create_account.hide();
            this.form = {
                id: '',
                code: '',
                name: ''
            };
        },
        getTaxPaymentList(page) {
            this.$store.dispatch("TaxPayment/getTaxPaymentAccount", {
                page: page,
                code: this.search.code,
            }).then(res => {
                this.tableList = res.data;
                this.dataPaginate = {
                    current_page: res.current_page,
                    from: res.from,
                    last_page: res.last_page,
                    per_page: res.per_page,
                    total: res.total,
                    to: res.to
                }
            })
        },
        createTaxPaymentAccount() {
            this.showTaxPaymentAccountModal();
            this.generateAccountCode();
        },
        saveTaxPaymentAccount() {
            this.$store.dispatch("TaxPayment/saveTaxPaymentAccount", {
                id: this.form.id,
                data: this.form
            }).then(() => {
                this.getTaxPaymentList();
            })
            this.hideTaxPaymentAccountModal();
        },
        showTaxPaymentAccount(id) {
            this.$store.dispatch("TaxPayment/showTaxPaymentAccount", id).then(res => {
                //console.log(res);
                this.form = res;
                this.showTaxPaymentAccountModal();
            })
        },
        deleteTaxPaymentAccount(id) {
            this.$store.dispatch("TaxPayment/deleteTaxPaymentAccount", id)
        },
        generateAccountCode() {
            this.$store.dispatch("TaxPayment/generateTaxPaymentCode").then(res => {
                this.form.code = res;
            });
        }
    }
}
</script>

<style scoped>

</style>
